<template>
  <div>
    <b-col class="zone-main-title">
      <h1 class="main-title">
        Listes
        <span class="separator" />
      </h1>
    </b-col>
    <ListeThematiques />
  </div>
</template>

<script>
import ListeThematiques from "@/components/thematiques/ListeThematiques.vue";

export default {
  name: "Thematiques",
  components: {
    ListeThematiques,
  },
};
</script>
<style lang="scss" scoped></style>
